function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
const BodyStyled = styled(_ref => {
  let { ...props
  } = _ref;
  delete props.hasMeta;
  return /*#__PURE__*/React.createElement("div", props);
}).withConfig({
  componentId: "sc-1xht6tl-0"
})(["word-wrap:break-all;word-wrap:break-word;hyphens:auto;overflow:hidden;position:relative;", ";"], _ref2 => {
  let {
    hasMeta
  } = _ref2;
  return hasMeta ? `padding: 0 0 1.5rem;` : "";
});

const Body = _ref3 => {
  let {
    hasMeta,
    children,
    ...props
  } = _ref3;
  return /*#__PURE__*/React.createElement(BodyStyled, _extends({
    hasMeta: hasMeta
  }, props), children);
};

Body.propTypes = {
  /** Body Contents */
  children: PropTypes.node.isRequired,

  /** Indicate if the body should account for neighboring meta information */
  hasMeta: PropTypes.string
};
export default Body;